import { Utils } from '../Utils';

const CHECK_SESSION_REQUEST = 'CHECK_SESSION_REQUEST';
const CHECK_SESSION_SUCCESS = 'CHECK_SESSION_SUCCESS';
const CHECK_SESSION_FAILURE = 'CHECK_SESSION_FAILURE';
const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

const DEFAULT_STATE = {
  user: null,
  isAuthenticated: false,
  isChecking: false,   // Will be set to true when checkSession is called
  isLoggingIn: false,
  error: null
};

const userReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case CHECK_SESSION_REQUEST:
      return Utils.update(state, { isChecking: true, error: null });

    case CHECK_SESSION_SUCCESS:
      return Utils.update(state, {
        user: action.user,
        isAuthenticated: true,
        isChecking: false
      });

    case CHECK_SESSION_FAILURE:
      return Utils.update(state, {
        user: null,
        isAuthenticated: false,
        isChecking: false
      });

    case LOGIN_REQUEST:
      return Utils.update(state, { isLoggingIn: true, error: null });

    case LOGIN_SUCCESS:
      return Utils.update(state, {
        user: action.user,
        isAuthenticated: true,
        isLoggingIn: false
      });

    case LOGIN_FAILURE:
      return Utils.update(state, {
        isLoggingIn: false,
        error: action.error
      });

    case LOGOUT_SUCCESS:
      return Utils.update(state, {
        user: null,
        isAuthenticated: false,
        error: null
      });

    default:
      return state;
  }
};

export default userReducer;
